module.exports = __webpack_public_path__ + "img/组38.849b0dd9.png";